export default "__VITE_ASSET__DSbEaK0U__"